import axios, { RawAxiosRequestHeaders, AxiosError, InternalAxiosRequestConfig } from 'axios';

// internal
import { getAccess, setAccess, getRefresh, setRefresh, delAccess, delRefresh } from './token';
import { getDomain } from './endpoint';
import { appId } from './app-id';

export interface OptionType {
  timeout?: number;
  headers?: RawAxiosRequestHeaders;
  clientAuth?: boolean;
  client?: string
}

interface ConfigType extends InternalAxiosRequestConfig {
  _retry: boolean;
}

export const request = (baseUri: string, opts?: OptionType) => {
  const instance = axios.create({
    baseURL: baseUri,
    timeout: opts?.timeout,
    headers: { 'Content-Type': 'application/json', ...(opts?.headers || {}) },
  });

  if (opts?.clientAuth) {

    // Auto assign token
    instance.interceptors.request.use(
      (request) => {
        const accessToken = getAccess();
        if (accessToken) {
          request.headers['Authorization'] = `Bearer ${accessToken}`;
        }
        return request;
      },
      (err) => {
        return Promise.reject(err);
      }
    );

    // Implement auto refresh token
    instance.interceptors.response.use(
      (response) => response,
      async (err: AxiosError) => {
        const currentUrl = window.location.href;
        const originalRequest = err.config as ConfigType;
        if (err?.response?.status === 401 && !originalRequest._retry) {
          originalRequest._retry = true;

          try {
            const { data } = await axios({
              url: `${baseUri}/auth/token`,
              method: 'POST',
              headers: {
                Authorization: `Bearer ${getRefresh()}`,
              },
              withCredentials: true,
            });

            const { refresh_token, access_token } = data.data;
            setAccess(access_token);
            setRefresh(refresh_token);

            // Update the authorization header with the new access token.
            instance.defaults.headers.common['Authorization'] = `Bearer ${access_token}`;

            return instance(originalRequest);
          } catch (error) {
            delAccess();
            delRefresh();
            let uri = ((await getDomain('auth')).auth)
            if (opts?.client) {
              uri += `/${opts?.client}`
            }
            uri += `?app=${appId}&redirect_uri=${currentUrl}`
            window.location.href = uri

            return Promise.reject(error);
          }
        }

        return Promise.reject(err);
      }
    );
  }

  return instance;
};
